import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  loadEventDetailPage,
  unloadEventDetailPage
} from "../../redux/actions/asset.actions";
import Nav from "../../components/Nav";
import Header from "../../components/Header";
import * as DateHelper from "../../utils/date.formatter";
import { REACT_APP_MODE } from "../../config";
import GoogleMapReact from "google-map-react";
import { Translation } from "react-i18next";
import i18n from "../../languages/lang.js";

function Event({}) {
  let { key } = useParams();
  const asset = useSelector(state => state.asset);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadEventDetailPage(key));
    return () => dispatch(unloadEventDetailPage()); // => componentWillUnmount
  }, [key]);

  if (!asset.event) {
    return (
      <Translation>
        {t => (
          <div id="main">
            <Nav selected={"events"} />
            <div id="content">
              <Header />
              <div id="loading">{t("system.loading")}</div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
  const event = asset.event;
  return (
    <Translation>
      {t => (
        <div id="main">
          <Nav selected={"events"} />
          <div id="content">
            <Header />
            <div className="content-wrap">
              <div className="box-header">
                <span className="header-info">
                  {DateHelper.toLocalString(event.created)}
                </span>
                {event.asset ? (
                  <h2>
                    <Link to={`/assets/${event.asset}`}>
                      {event.asset_name}
                    </Link>{" "}
                    &gt; {event.key}
                  </h2>
                ) : (
                  <h2>{event.key}</h2>
                )}
              </div>
              <ul className="dashboard-list">
                <li>
                  <strong>{t("common.name")}</strong>
                  <em>{event.asset_name}</em>
                </li>
                <li>
                  <strong>{t("common.type")}</strong>
                  <em>{event.type}</em>
                </li>
                {event.type.toUpperCase() === "LOCATION" ? (
                  <li>
                    <strong>{t("common.location")}</strong>
                    <em className="shorter">
                      {`lon:${event.value.longitude}, lat:${event.value.latitude}`}
                    </em>
                  </li>
                ) : event.type.toUpperCase() === "TEMPERATURE" ? (
                  <li>
                    <strong>{t("event.label_last_check")}</strong>
                    <em>{event.value} °C</em>
                  </li>
                ) : (
                  <li>
                    <strong>{t("common.value")}</strong>
                    <em>{event.value}</em>
                  </li>
                )}
              </ul>
              {event.type.toUpperCase() === "LOCATION" ? (
                <div className="map-box">
                  <GoogleMapReact
                    bootstrapURLKeys={{
                      key: "AIzaSyChP3vkShVB0f9F_pWR-f9RoevDAuY5lPQ"
                    }}
                    defaultCenter={{
                      lat: event.value.latitude,
                      lng: event.value.longitude
                    }}
                    defaultZoom={11}
                  >
                    <img
                      className="map-pin"
                      src="/pin.png"
                      lat={event.value.latitude}
                      lng={event.value.longitude}
                    />
                  </GoogleMapReact>
                </div>
              ) : (
                ""
              )}
              {event.campaign_key &&
              event.campaign_name &&
              event.campaign_item_key ? (
                <div className="campaign-box">
                  {t("event.trigger_prompt")}{" "}
                  <Link to={`/campaigns/items/${event.campaign_item_key}`}>
                    {event.campaign_name} - {event.campaign_key}
                  </Link>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      )}
    </Translation>
  );
}

export default Event;
